var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.773 17.854h-2.158m2.158-2.497h-4.67m4.67-2.503h-3.158M11.56 4.837h-.011m0 0H6.026A2.447 2.447 0 0 0 3.58 7.284v2.379m7.969-4.826c.09-.206.175-.404.254-.59A2.04 2.04 0 0 1 13.674 3h4.18A3.146 3.146 0 0 1 21 6.146v11.708A3.146 3.146 0 0 1 17.854 21H6.146A3.146 3.146 0 0 1 3 17.854v-6.371c0-.678.215-1.306.58-1.82m7.969-4.826c-.551 1.263-1.28 2.828-1.772 3.5H6.146c-1.06 0-1.996.524-2.566 1.326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.b86dd67cde20d6c138eafdff1e731511.svg";
export { ForwardRef as ReactComponent };